<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.nameZh" clearable placeholder="分类中文名" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.nameEn" clearable placeholder="分类英文名" />
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.isActive" clearable placeholder="启用状态">
            <el-option label="启用" :value="true" />
            <el-option label="停用" :value="false" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="handleAdd">新增分类</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        :data="results"
        height="100%"
        border
        stripe
        highlight-current-row
      >
        <el-table-column prop="id" label="ID" min-width="220" />
        <el-table-column prop="nameZh" label="中文名" min-width="140" />
        <el-table-column prop="nameEn" label="英文名" min-width="160" />
        <el-table-column prop="exampleZh" label="中文示例" min-width="220" show-overflow-tooltip />
        <el-table-column prop="exampleEn" label="英文示例" min-width="240" show-overflow-tooltip />
        <el-table-column prop="sortOrder" label="排序" width="90" align="center" />
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isActive ? 'success' : 'info'">
              {{ scope.row.isActive ? "启用" : "停用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteSubmit(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>

    <el-dialog
      :visible.sync="formVisible"
      :close-on-click-modal="false"
      :title="formMode === 'create' ? '新增分类' : '编辑分类'"
      width="720px"
    >
      <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="90px">
        <el-form-item label="中文名" prop="nameZh">
          <el-input v-model.trim="editForm.nameZh" placeholder="请输入分类中文名" />
        </el-form-item>
        <el-form-item label="英文名" prop="nameEn">
          <el-input v-model.trim="editForm.nameEn" placeholder="请输入分类英文名" />
        </el-form-item>
        <el-form-item label="中文示例" prop="exampleZh">
          <el-input
            v-model.trim="editForm.exampleZh"
            type="textarea"
            :rows="2"
            placeholder="例如：Logo设计、落地页、审计"
          />
        </el-form-item>
        <el-form-item label="英文示例" prop="exampleEn">
          <el-input
            v-model.trim="editForm.exampleEn"
            type="textarea"
            :rows="2"
            placeholder="For example: logo design, landing page, audit"
          />
        </el-form-item>
        <el-form-item label="排序" prop="sortOrder">
          <el-input-number v-model="editForm.sortOrder" :min="0" controls-position="right" style="width: 100%" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="editForm.isActive" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="submitForm">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";

const createEmptyMarketCategoryForm = () => ({
  id: "",
  nameZh: "",
  nameEn: "",
  exampleZh: "",
  exampleEn: "",
  sortOrder: 0,
  isActive: true,
});

export default {
  name: "MarketCategories",
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {
        page: 1,
        limit: 20,
        total: 0,
      },
      filters: {
        nameZh: "",
        nameEn: "",
        isActive: "",
      },
      formVisible: false,
      formMode: "create",
      submitLoading: false,
      editForm: createEmptyMarketCategoryForm(),
      editFormRules: {
        nameZh: [{ required: true, message: "请输入分类中文名", trigger: "blur" }],
        nameEn: [{ required: true, message: "请输入分类英文名", trigger: "blur" }],
      },
    };
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    emptyForm() {
      return createEmptyMarketCategoryForm();
    },
    search() {
      this.page.page = 1;
      this.list();
    },
    list() {
      this.listLoading = true;
      const params = {
        name_zh: this.filters.nameZh,
        name_en: this.filters.nameEn,
        isActive: this.filters.isActive,
        page: this.page.page,
        limit: this.page.limit,
      };
      this.axios
        .form("/api/admin/market-category/list", params)
        .then((data) => {
          this.results = data.results || [];
          this.page = data.page || { page: 1, limit: 20, total: 0 };
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    handleAdd() {
      this.formMode = "create";
      this.editForm = this.emptyForm();
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate();
      });
    },
    handleEdit(row) {
      this.axios
        .get("/api/admin/market-category/" + row.id)
        .then((data) => {
          this.formMode = "edit";
          this.editForm = Object.assign({}, this.emptyForm(), data);
          this.formVisible = true;
          this.$nextTick(() => {
            this.$refs.editForm && this.$refs.editForm.clearValidate();
          });
        })
        .catch((err) => {
          this.$notify.error({ title: "错误", message: err.message || err });
        });
    },
    submitForm() {
      this.$refs.editForm.validate((valid) => {
        if (!valid) {
          return false;
        }
        const apiUrl =
          this.formMode === "create"
            ? "/api/admin/market-category/create"
            : "/api/admin/market-category/update";
        this.submitLoading = true;
        this.axios
          .form(apiUrl, this.editForm)
          .then(() => {
            this.$message({ type: "success", message: this.formMode === "create" ? "创建成功" : "更新成功" });
            this.formVisible = false;
            this.list();
          })
          .catch((err) => {
            this.$notify.error({ title: "错误", message: err.message || err });
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
    deleteSubmit(row) {
      this.$confirm("是否删除该分类？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios.form("/api/admin/market-category/delete", { id: row.id }).then(() => {
            this.$message({ type: "success", message: "删除成功" });
            this.list();
          });
        })
        .catch(() => {});
    },
  },
};
</script>
